import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  h5: {
    paddingTop: theme.spacing(0.625),
  },
  formSection: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(1.25),
  },
  form: {
    textAlign: 'left',
    '& input': {
      paddingRight: theme.spacing(1.25),
      padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    },
  },
  inputGrid: {
    paddingRight: theme.spacing(2.5),
  },
  inputError: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.main,
  },
  container: {
    textAlign: 'left',
  },
  submitButton: {
    paddingTop: theme.spacing(1.25),
  },
}));
